'use client';

import clsx from 'clsx';
import { FC, useEffect, useState } from 'react';
import Icon from '~/components/icon';

import styles from './styles.module.css';

const MOBILE_QUERY = '(width < 768px)';
const MOBILE_THRESHOLD = 300;
const DEFAULT_THRESHOLD = 400;

const ScrollTopButton: FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const mobileQuery = window.matchMedia(MOBILE_QUERY);

    const onScroll = (): void => {
      const threshold = mobileQuery.matches ? MOBILE_THRESHOLD : DEFAULT_THRESHOLD;
      setVisible(window.scrollY > threshold);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    mobileQuery.addEventListener('change', onScroll);

    return () => {
      window.removeEventListener('scroll', onScroll);
      mobileQuery.removeEventListener('change', onScroll);
    };
  }, []);

  const onClick = (): void => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  };

  return (
    <button
      type="button"
      aria-label="Наверх"
      tabIndex={visible ? 0 : -1}
      aria-hidden={!visible}
      onClick={onClick}
      className={clsx(styles.button, visible && styles.visible)}
    >
      <Icon name="arrow-up" className={styles.icon} />
    </button>
  );
};

export default ScrollTopButton;
